import backendV2Service from './backend-v2.service';

export interface LegacyResponse<T> {
  status: string;
  content: T;
}

export interface PaginatedResult<T> {
  items: T[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ConglomerateListItem {
  id: number;
  name: string;
  countryId: number;
  active: boolean;
  country?: { id: number; name: string };
  totalSchools: number;
  totalLicenses: number;
}

type ConglomerateSchoolListItem = {
  id: number;
  name: string;
  active: boolean;
};

export interface CreateConglomerateDto {
  name: string;
  countryId: number;
  active?: boolean;
}

export interface UpdateConglomerateDto {
  name?: string;
  countryId?: number;
  active?: boolean;
}

const unwrap = <T>(request: Promise<{ data: LegacyResponse<T> }>) => request
  .then(({ data }) => data);

export default {
  list: (params: {
    page?: number;
    limit?: number;
    name?: string;
    country_id?: number;
    active?: boolean;
  }): Promise<LegacyResponse<PaginatedResult<ConglomerateListItem>>> => unwrap(
    backendV2Service.get<LegacyResponse<PaginatedResult<ConglomerateListItem>>>('/school-groups', { params }),
  ),

  findOne: (id: number | string): Promise<LegacyResponse<ConglomerateListItem>> => unwrap(
    backendV2Service.get<LegacyResponse<ConglomerateListItem>>(`/school-groups/${id}`),
  ),

  create: (data: CreateConglomerateDto): Promise<LegacyResponse<ConglomerateListItem>> => unwrap(
    backendV2Service.post<LegacyResponse<ConglomerateListItem>>('/school-groups', data),
  ),

  update: (
    id: number | string,
    data: UpdateConglomerateDto,
  ): Promise<LegacyResponse<ConglomerateListItem>> => unwrap(
    backendV2Service.put<LegacyResponse<ConglomerateListItem>>(`/school-groups/${id}`, data),
  ),

  remove: (id: number | string): Promise<void> => backendV2Service.delete(`/school-groups/${id}`).then(() => undefined),

  getSchools: (
    id: number | string,
  ): Promise<LegacyResponse<ConglomerateSchoolListItem[]>> => unwrap(
    backendV2Service.get<LegacyResponse<ConglomerateSchoolListItem[]>>(`/school-groups/${id}/schools`),
  ),

  unlinkSchool: (
    groupId: number | string,
    schoolId: number | string,
  ): Promise<LegacyResponse<{ success: true }>> => unwrap(
    backendV2Service.put<LegacyResponse<{ success: true }>>(`/school-groups/${groupId}/schools/${schoolId}/unlink`),
  ),
};
